<template>
  <div>
    <el-card shadow="never" class="lefts">
      <div>
        <img src="../assets/img/bg1.png" class="img" />
      </div>
      <el-menu class="el-menu-vertical-demo" collapse-transition router :default-active="$route.path" unique-opened
        background-color="#ffffff" text-color="#000000" active-text-color="#A566FF">
        <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuid.toString()">
          <template slot="title">
            <i class="iconfont" :class="menu.icon"></i>
            <span>{{ menu.menuname }}</span>
          </template>
          <el-menu-item v-for="chmenu in menu.menus" :index="'/' + chmenu.url" :key="chmenu.menuid">
            <span>{{ chmenu.menuname }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isCollapse: false,
      allmenu: [],
      divs2: true,

    };
  },

  created() {
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: "el-icon-house",
          menuname: "首页",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 11,
            icon: "el-icon-menu",
            menuname: "打卡统计",
            hasThird: null,
            url: "home/index",
            menus: null,
            list: []
          }],
        },
        {
          menuid: 2,
          icon: "el-icon-collection",
          menuname: "词书管理",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 20,
            icon: "el-icon-menu",
            menuname: "词书列表",
            hasThird: null,
            url: "book/list",
            menus: null,
          },
          {
            menuid: 21,
            icon: "el-icon-menu",
            menuname: "词书分类",
            hasThird: null,
            url: "book/category",
            menus: null,
          }],
        },
        {
          menuid: 3,
          icon: "el-icon-present",
          menuname: "排行榜",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 30,
            icon: "el-icon-document",
            menuname: "排行榜设置",
            hasThird: null,
            url: "userrank/list",
            menus: null,
          }, {
            menuid: 31,
            icon: "el-icon-document",
            menuname: "排行榜",
            hasThird: null,
            url: "userrank/detail",
            menus: null,
          }, {
            menuid: 32,
            icon: "el-icon-document",
            menuname: "兑换列表",
            hasThird: null,
            url: "shipping/list",
            menus: null,
          }],
        },
        {
          menuid: 4,
          icon: "el-icon-user",
          menuname: "平台用户",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 40,
            icon: "el-icon-document",
            menuname: "用户列表",
            hasThird: null,
            url: "users/list",
            menus: null,
          }],
        },
        {
          menuid: 5,
          icon: "el-icon-document",
          menuname: "意见管理",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 50,
            icon: "el-icon-document",
            menuname: "意见反馈",
            hasThird: null,
            url: "feedback/list",
            menus: null,
          }],
        },
        {
          menuid: 6,
          icon: "el-icon-user",
          menuname: "管理员",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 60,
            icon: "el-icon-document",
            menuname: "管理员列表",
            hasThird: null,
            url: "managers/list",
            menus: null,
          }],
        },
        {
          menuid: 9,
          icon: "el-icon-setting",
          menuname: "系统设置",
          hasThird: null,
          url: "",
          menus: [{
            menuid: 93,
            icon: "el-icon-picture",
            menuname: "Banner管理",
            hasThird: null,
            url: "banners/list",
            menus: null,
          }, {
            menuid: 91,
            icon: "el-icon-document",
            menuname: "打卡积分",
            hasThird: null,
            url: "system/config",
            menus: null,
          }, {
            menuid: 92,
            icon: "el-icon-document",
            menuname: "平台消息",
            hasThird: null,
            url: "system/messages",
            menus: null,
          }],
        }
      ]
    }

    this.allmenu = res.data;
  },
  methods: {

  }
};
</script>

<style>
.lefts {
  height: 95vh;
  background-color: #ffffff;
  text-align: center;
}

.lefts .img {
  max-width: 100%;
}

.lefts .el-submenu__title {
  padding: 0 20px !important;
  text-align: left;
}



.lefts .el-menu-item-group__title {
  padding: 0 !important;
}

.lefts .el-submenu .el-menu-item {
  min-width: 120px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue